export default "__VITE_ASSET__DqnzT8MI__"